var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptumrx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147.8 28.8",
    style: {
      enableBackground: "new 0 0 147.8 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4D4F;}\n\t.st1{fill:#FF612B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Optum_Rx"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,22.2V5.4h5.3l0,2c1.1-1.5,2.6-2.3,4.5-2.3c2.3,0,3.9,1.1,4.8,2.7c1.1-1.8,3.1-2.7,5.2-2.7   c3.7,0,5.7,2.8,5.7,6.2v10.8h-5.4v-10c0-1.6-1-2.6-2.3-2.6s-2.3,1-2.3,2.6v10h-5.4v-10c0-1.6-1-2.6-2.3-2.6c-1.3,0-2.3,1-2.3,2.6   v10L73.8,22.2L73.8,22.2z M72,15.8c0,4.3-3.5,6.8-7.9,6.8s-7.9-2.5-7.9-6.8V5.4h5.5v10.3c0,1.5,1,2.4,2.4,2.4   c1.4,0,2.4-0.9,2.4-2.4V5.4H72V15.8z M54.8,9.7V5.4h-4.5V1.1h-5.4v15.1c0,4.2,2.5,6.3,6.5,6.3c1.2,0,2.4-0.1,3.5-0.6v-4.3   C54,17.9,53.3,18,52.7,18c-1.5,0-2.4-0.7-2.4-2.2v-6H54.8z M38,13.8c0,2.4-1.8,4.2-3.9,4.2c-2.2,0-4-1.8-4-4.2c0-2.4,1.8-4.2,4-4.2   C36.2,9.6,38,11.4,38,13.8z M30.1,28.8v-8.3c1.4,1.3,3.2,2,5.2,2c4.6,0,8.1-3.9,8.1-8.7c0-4.8-3.6-8.7-8.1-8.7   c-2.1,0-4,0.8-5.4,2.2l0-1.9h-5.3v23.4H30.1z M17.2,11.2c0,3.5-2.6,6-5.7,6s-5.7-2.6-5.7-6c0-3.5,2.5-6,5.7-6S17.2,7.8,17.2,11.2z    M11.5,0C5.1,0,0,5,0,11.2s5.1,11.2,11.5,11.2S23,17.5,23,11.2S17.9,0,11.5,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptumrx);
export default __webpack_public_path__ + "static/media/Optumrx.d89183a1ecc17e1ceadca9186ef77bd9.svg";
export { ForwardRef as ReactComponent };